<template>
  <div class="container">
    <div class="head_code">
      <div class="headerCode">
        <div class="headerFlexCode">
          库存码：{{userCode}}
        </div>
        <div class="headerFlexCode">
          奖励库存码：{{rewardPCode}}
        </div>
      </div>
    </div>
<!-- style="height:calc(100% - 46px)" -->
    <div v-if="list.length > 0"
         >
      <van-list v-model="loading"
                :finished="finished"
                finished-text="没有更多了~"
                :immediate-check="false"
                @load="onLoad">
        <div class="list"
             v-for="item,index in list"
             :key="index">
          <div class="every">
            <div>
              <div class="title">{{ item.reason }}</div>
              <div class="timer">{{ item.dateTime }}</div>
            </div>

            <div class="add"
                 v-if="item.type ==1">
              +{{item.amount}}
            </div>
            <div class="reduce"
                 v-if="item.type ==0">
              -{{item.amount}}
            </div>
          </div>
        </div>
      </van-list>

    </div>
    <div class="emptyPage"
         v-if="list.length == 0">
      <div class="nullPage">
        <img src="../../../assets/images/update.png"
             alt />
      </div>
      <div class="noAgentText">暂无明细</div>
    </div>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import {
  Row,
  Col,
  Icon,
  Cell,
  CellGroup,
  Dialog,
  Grid,
  GridItem,
  Image,
  List,
  PullRefresh,
  Loading,
  Overlay
} from "vant";
import service from "../../api/inventoryCode/index.js";
import { mapGetters } from "vuex";
import loading from "../../components/loading/loading";
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Dialog.name]: Dialog,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Image.name]: Image,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Loading.name]: Loading,
    [Overlay.name]: Overlay,
    loading
  },

  data () {
    return {
      page: 1,
      pageSize: 20,
      list: [],
      loading: false,
      finished: false,
      // refreshing: false,
      firstLoading: true,
      isLoading: false, //loading状态
      userCode: 0,//用户库存码
      rewardPCode: 0, //用户库存码
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted () {
    this.init();
  },
  methods: {
    onLoad () {
      this.page++;
      this.getList().then((list) => {
        this.list = this.list.concat(list.userPCodeRecords.items);
        this.loading = false;
        this.userCode = list.normal;
        this.rewardPCode = list.reward;
        if (list.userPCodeRecords.totalCount <= this.list.length) {
          this.finished = true;
        }
      });
    },

    getList () {
      return new Promise((resolve, reject) => {
        service
          .pCodePageList(this.page, this.pageSize)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            // reject();
          });
      });
    },
    init () {
      this.firstLoading = true;
      this.loading = false;
      this.finished = false;
      this.getList().then((list) => {
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
        this.firstLoading = false;
        if (list.userPCodeRecords) {
          this.loading = false;
          this.list = []
          if (list.userPCodeRecords.items.length > 0) {
            this.list = list.userPCodeRecords.items;
          }
          this.userCode = list.normal;
          this.rewardPCode = list.reward;
          console.log(this.list.length, list.userPCodeRecords.totalCount, 181)
          if (list.userPCodeRecords.totalCount <= this.list.length) {
            this.finished = true;
          }
        } else {
          this.list = [];
          this.loading = false;
        }
      });
    },
  }
};
</script>
<style lang="less" scoped>
@deep: ~'>>>';
.container {
  height: 100vh;
  .head_code {
    position: sticky;
    top: 0;
    width: 100%;
    background: #f8f8f8;
    .headerCode {
      display: flex;
      height: 46px;
      line-height: 46px;
      padding: 0 24px;
    }
  }

  .headerFlexCode {
    flex: 1;
  }
  .emptyPage {
    width: 100%;
    text-align: center;
    font-size: 3.2vw;
    color: #92909a;
    padding-top: 208px;
    height: calc(100vh - 208px);
  }
  .list {
    margin: 0 12px;
    background: #fff;
    margin-bottom: 8px;
    box-shadow: 0px 4px 8px 0px #e6e6e6;
    border-radius: 8px;
    height: 70px;
  }
  .every {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 12px;
  }

  .flex {
    display: flex;
    align-items: center;
  }

  .timer {
    height: 12px;
    font-size: 12px;
    color: #999999;
    margin-top: 8px;
  }
  .add {
    font-size: 16px;
    font-weight: 600;
    color: #19c15c;
  }
  .reduce {
    font-size: 16px;
    font-weight: 600;
    color: #f00724;
  }
}
</style>